import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    DatePicker,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag,
    Select,
    Input,
    Modal,
    ExpandableText,
    Badge,
    ImageFileId,
} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import SerialReceiveForm from "./serial_receive_form";
import SerialReceiveModal from "./serial_receive_modal"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import { ItemForm } from "../../Library/views/BackStage/item_form";
import { useItem } from "../../Library/controllers/ItemController"
import BookImages from "../../Library/components/book_images";
import { getItemRequestErrorMessage } from "./item_request_error";
import { ru } from "date-fns/locale";

const SerialReceiveTable = ({
    rowKey = "serialid",
    keyPrefix = "cataloging.serial_receive",
    showAllColumns = true,
    propsShowColumns,
    propsSubscriptionOrderlistId,
    propsSubscriptionid,
    propsBranchcode,
    propsBiblionumber,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    permission_level = null, 
    conciseBibTitle = false,

}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate()

    const [tableSearchParams, setTableSearchParams] = useState({
        subscription_orderlist_id: propsSubscriptionOrderlistId || null,
        biblionumber: propsBiblionumber || null,
        // subscriptionid: propsSubscriptionid || null,
        start_planneddate: dayjs().startOf('year').format('YYYY-MM-DD'),
        end_planneddate: dayjs().endOf('year').format('YYYY-MM-DD'),
        branchcode: propsBranchcode ? propsBranchcode : null
    });
    const receiveSerialStatusOptions = [
        { value: 1, label: t('expected'), tagColor: "primary" },
        { value: 2, label: t('arrived'), tagColor: "success" },
        { value: 3, label: t('late'), tagColor: "error" },
        { value: 4, label: t('missing'), tagColor: "secondary" },
        { value: 41, label: t('missing_never_received'), tagColor: "secondary" },
        { value: 42, label: t('missing_sold_out'), tagColor: "secondary" },
        { value: 43, label: t('missing_damaged'), tagColor: "secondary" },
        { value: 44, label: t('missing_lost'), tagColor: "secondary" },
        { value: 7, label: t('claimed'), tagColor: "geekblue" },
        { value: 5, label: t('not_available'), tagColor: "cyan-inverse" },
        { value: 6, label: t('delete'), tagColor: "gold-inverse" }
    ];
    const [receiveData, setReceiveData] = useState([])
    const [receiveValue, setReceiveValue] = useState(null)
    const [options, setOptions] = useState({
        withdrawn_options: [],
        call_number_source_options: [],
        damaged_options: [],
        restricted_options: [],
        notforloan_options: [],
        collection_options: [],
        library_options: [],
        location_options: [],
        shelving_control_number_options: [],
        item_type_options: []
    })
    const [serialOption, setSerialOption] = useState([])
    const [serialBibOption, setSerialBibOption] = useState([])

    const columns = [
        // {
        //     title: t("biblionumber"),
        //     key: "biblionumber",
        //     dataIndex: "biblionumber",
        // },
        {
            title: "書封圖片",
            dataIndex: 'bib_cover_images',
            key: 'bib_cover_images',
            width: "20px",
            disabled: true,
            sorter: false,
            render: (text, record, index) => {
                let bookImageData = Array.isArray(text)
                    ? text.map((file_id) => ({ file_id }))
                    : []
                if (bookImageData.length === 0) {
                    bookImageData = [{
                        src: `https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=${record?.bibitem_isbn || ""}`,
                    }]
                }

                return <div style={{ width: "80px" }}>
                    <BookImages
                        bookImageData={bookImageData}
                        biblionumber={record?.biblionumber}
                        title={record?.bib_title_subtitle}
                        isbn={record?.bibitem_isbn}
                        showNavigation={false}
                        autoPlay
                        onChanged={() => actionRef.current?.reload()}
                    />
                </div>
            }
        },
        {
            title: t("serial", { defaultValue: "期刊名稱" }),
            key: "bib_title_subtitle",
            dataIndex: "bib_title_subtitle",

            render: (text, record, index) => {
                return <Row justify="center">
                    <Col
                        style={{
                            cursor: "pointer",
                            maxWidth: "200px"
                        }}
                        span={24}
                        onClick={() => {
                            navigate(`/library/backstage/BookDetail?bib_biblionumber=${record?.biblionumber}`)
                        }}>
                        <Typography.P>
                            {text}
                        </Typography.P>
                    </Col>
                </Row>
            }
        },

        {
            title: "接收分館",
            key: "branchname",
            dataIndex: "branchname",
        },
        {
            title: t("serialseq", { defaultValue: "期刊序號" }),
            key: "serialseq",
            dataIndex: "serialseq",
        },
        {
            title: t("planneddate", { defaultValue: "到刊日期" }),
            key: "planneddate",
            dataIndex: "planneddate",
        },
        {
            title: `到刊狀態`,
            key: "status",
            dataIndex: "status",
            render: (text, record, index) => {
                let item_data = record?.item_data || []
                let itemFirst = item_data?.find((_) => true)
                let labelArray = [itemFirst?.item_notforloan_authorised_values, itemFirst?.item_damaged_authorised_values, itemFirst?.item_restricted_authorised_values, itemFirst?.item_withdrawn_authorised_values]
                labelArray = labelArray.filter((e) => !!e)
                let label = labelArray.join(",")
                let statusValue = receiveSerialStatusOptions.find((ele) => ele?.value === text)
                let status = statusValue?.label
                return <Row justify="center" gutter={[4, 4]}>
                    <Col>
                        <Tag color={statusValue?.tagColor}>
                            {status}
                        </Tag>
                    </Col>
                </Row>
            }
        },

        {
            title: t("publisheddate", { defaultValue: "出版日期" }),
            key: "publisheddate",
            dataIndex: "publisheddate",
        },
        // {
        //     title: t("claimdate"),
        //     key: "claimdate",
        //     dataIndex: "claimdate",
        // },
        // {
        //     title: t("claims_count"),
        //     key: "claims_count",
        //     dataIndex: "claims_count",
        // },
       
        {
            title: "已點收館藏",
            key: "item_data",
            dataIndex: "item_data",
            align: "center",
            render: (text, record, index) => {
                let receiveItemCount = text?.length || 0
                return <Button
                    disabled={parseInt(record?.status) !== 2}
                    type={record?.item_data.length > 0 ? "" : "default"}
                    onClick={() => {
                        setReceiveData(record?.item_data)
                        setReceiveValue(record)
                        setReceiveItemDetailModalOpen(true)
                    }}>
                    {receiveItemCount}本
                </Button>
            }
        },
         {
            title: "館藏條碼",
            key: "routingnotes",
            dataIndex: "routingnotes",
            align: "center",
            render: (text, record, index) => {
                let item_data = record?.item_data || []
                let labelArray = item_data?.map((val) => val?.item_barcode)
                let label = labelArray.join(",")
                return <Row justify="center">
                    <Col>
                        {label}
                    </Col>
                </Row>
            }
        },
        {
            title: `流通狀態`,
            key: "status",
            dataIndex: "status",
            render: (text, record, index) => {
                let item_data = record?.item_data || []
                let itemFirst = item_data?.find((_) => true)
                let labelArray = [itemFirst?.item_notforloan_authorised_values, itemFirst?.item_damaged_authorised_values, itemFirst?.item_restricted_authorised_values, itemFirst?.item_withdrawn_authorised_values]
                labelArray = labelArray.filter((e) => !!e)
                let label = labelArray.join(",")
                let statusValue = receiveSerialStatusOptions.find((ele) => ele?.value === text)
                let status = statusValue?.label
                return <Row justify="center" gutter={[4, 4]}>
                    <Col>
                        <Tag color={!!label ? "red" : "success"}>
                            {!!itemFirst && (!!label ? label : "可借閱")}
                        </Tag>
                    </Col> 
                </Row>
            }
        },
    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : [])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const [form] = Form.useForm();
    const [receiveItemDetailModalOpen, setReceiveItemDetailModalOpen] = useState(false);
    const [receivePostModalOpen, setReceivePostModalOpen] = useState(false);



    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                // actionRef.current.reloadAndRest();
                // setLoading(false)
                // setReceivePostModalOpen(false)
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));

                actionRef.current.onTableSearch();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                setLoading(false)
                setReceivePostModalOpen(false)
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(values === undefined
                    ? t('modify_failure')
                    : getItemRequestErrorMessage(values, "修改", "期刊"));
                actionRef.current.reload();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };

    const onItemFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("館藏" + t('add_success'));
                actionRef.current.reloadAndRest();
                setLoading(false)
                setReceivePostModalOpen(false)
            } else if (axiosMode === "patch") {
                message.success("館藏" + t('modify_success'));
                actionRef.current.reload();
            } else if (axiosMode === "delete") {
                message.success("館藏" + t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(getItemRequestErrorMessage(values, "新增"));
                setLoading(false)
                setReceivePostModalOpen(false)
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(getItemRequestErrorMessage(values, "修改"));
                actionRef.current.reload();
            } else if (axiosMode === "delete") {
                message.error("館藏" + t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const SerialController = useCRUDController({
        apiRoute: "/koha/serial",
    })
    const SerialBibController = useCRUDController({
        apiRoute: "/koha/serial/bib/selection",
    })
    const SerialReceiveController = useCRUDController({
        apiRoute: "/koha/serial/receive",
        includePatchErrorDetails: true,
        onFinish,
        onBefore
    })
    const SerialOrderlistController = useCRUDController({
        apiRoute: "/library/subscription_orderlist",
        onFinish,
        onBefore
    })
    const ItemSerialController = useCRUDController({
        apiRoute: "/koha/item/serial",
        onFinish: onItemFinish,
        // onBefore
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const itemOptionsController = useCRUDController({ apiRoute: "/koha/item/api" })


    useEffect(() => {
        checkAll();
        SerialController.getData({

        }).then((response) => {
            let data = response?.data
            setSerialOption(data)
        })
        SerialBibController.getData({
            subscription_orderlist_id: tableSearchParams?.subscription_orderlist_id
        }).then((response) => {
            let data = response?.data
            setSerialBibOption(data)
        })
        libraryController.getData({})
        SerialOrderlistController.getData({})
        itemOptionsController.getData({
            itemnumber: "0"
        }).then((response) => {
            let datas = response?.data
            let firstData = datas?.find((ele) => true)
            setOptions((pre) => {
                return {
                    withdrawn_options: firstData?.withdrawn_options,
                    call_number_source_options: firstData?.call_number_source_options,
                    damaged_options: firstData?.damaged_options,
                    restricted_options: firstData?.restricted_options,
                    notforloan_options: firstData?.notforloan_options,
                    collection_options: firstData?.collection_options,
                    library_options: firstData?.library_options,
                    location_options: firstData?.location_options,
                    shelving_control_number_options: firstData?.shelving_control_number_options,
                    item_type_options: firstData?.item_type_options,
                }
            })
        })
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.onTableSearch()
    }, [tableSearchParams])
    useEffect(() => {
        setTableSearchParams((pre) => {
            return {
                ...pre,
                branchcode: propsBranchcode
            }
        })
    }, [propsBranchcode])
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <Modal
                title="已點收館藏"
                open={receiveItemDetailModalOpen}
                onClose={() => { setReceiveItemDetailModalOpen(false) }}
                closeText="關閉"
                close={true}
                width={1800}
            >
                <ReceivedItemTable
                    serialid={receiveValue?.serialid}
                    bib_biblionumber={receiveValue?.biblionumber}
                    receiveValue={receiveValue}
                />
            </Modal>
        </Col>
        <Col span={24}>
            <SerialReceiveModal
                propsForm={form}
                propsOpen={receivePostModalOpen}
                propsSetOpen={setReceivePostModalOpen}
                propsLoading={loading}
                propsSetLoading={setLoading}
                openButtonText={"額外點收期刊新增"}
                onFinish={(value) => {
                    let newValue = Object.fromEntries(
                        Object.entries(value).map(([key, val]) => [key, (val === undefined || val === "") ? null : val])
                    );
                    let postData = [newValue]
                    SerialReceiveController.postData(postData)
                }}
            />
        </Col>
        <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24} >
            <Row align="middle">
                <Col span={24}>
                    <Typography.Title level={4}>
                        接收分館：
                    </Typography.Title>
                </Col>
                <Col span={24}>
                    <Select
                        allowClear={true}
                        defaultValue={tableSearchParams?.branchcode}
                        value={tableSearchParams?.branchcode}
                        options={libraryController?.ResponseData?.map((value) => {
                            return {
                                label: `${value?.branchname}`,
                                value: value?.branchcode
                            }
                        })}
                        onChange={(value) => {
                            setTableSearchParams((pre) => {
                                return {
                                    ...pre,
                                    branchcode: value
                                }
                            })
                        }}

                    />
                </Col>
            </Row>
        </Col>
        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
            <Row align="middle">
                <Col span={24}>
                    <Typography.Title level={4}>
                        訂單：
                    </Typography.Title>
                </Col>
                <Col span={24}>
                    <Select
                        allowClear={true}
                        value={tableSearchParams?.subscription_orderlist_id}
                        options={SerialOrderlistController.ResponseData?.map((value) => {
                            let subscription_orderlist_task_data = value?.subscription_orderlist_task_data || []
                            let subscription_orderlist_task_data_first = subscription_orderlist_task_data?.find((ele) => true)
                            let tasName = subscription_orderlist_task_data_first?.task_name
                            let subscription_orderlist_serial = subscription_orderlist_task_data_first?.subscription_orderlist_serial
                            return {
                                label: `(${subscription_orderlist_serial || "-"}) ${tasName || ""}`,
                                value: value?.subscription_orderlist_id
                            }
                        })}
                        onChange={(value) => {
                            //訂閱期刊下拉選單
                            setSerialOption((pre) => {
                                if (!!value) {
                                    let newOptions = SerialOrderlistController.ResponseData.find((ele) => ele?.subscription_orderlist_id === value)
                                    let subscription_orderlist_items_data = newOptions?.subscription_orderlist_items_data || []
                                    return subscription_orderlist_items_data
                                }
                                else {
                                    return SerialController.ResponseData
                                }
                            })
                            // 書目/期刊名稱下拉選單
                            SerialBibController.getData({
                                subscription_orderlist_id: value
                            }).then((response) => {
                                let data = response?.data
                                setSerialBibOption(data)
                            })
                            setTableSearchParams((pre) => {
                                return {
                                    ...pre,
                                    subscription_orderlist_id: value,
                                    // subscriptionid: null,
                                    biblionumber: null
                                }
                            })
                        }}

                    />
                </Col>
            </Row>
        </Col>
        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}  >
            <Row align="middle">
                <Col span={24}>
                    <Typography.Title level={4}>
                        {t('serial', { defaultValue: "期刊名稱" })}：
                    </Typography.Title>
                </Col>
                <Col span={24}>
                    <Select
                        onlyValue={tableSearchParams?.biblionumber}
                        defaultValue={tableSearchParams?.biblionumber}
                        allowClear={true}
                        value={tableSearchParams?.biblionumber}
                        options={serialBibOption?.map((value) => {
                            return {
                                label: `${value?.title}`,
                                value: value?.biblionumber
                            }
                        })}
                        onChange={(value) => {
                            setTableSearchParams((pre) => {
                                return {
                                    ...pre,
                                    biblionumber: value
                                }
                            })
                        }}

                    />
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    ...tableSearchParams,
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <Typography.P>
                        {t('sort_hint', { defaultValue: "預設依期刊名稱排序，同一期刊依期刊序號由新到舊排列，點選欄位標頭可調整排序。" })}
                    </Typography.P>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return [
                        <Col span={24}>
                            <Row gutter={[4, 4]} align={"middle"}>
                                <Col>
                                    <Typography.P>
                                        {t('planneddate', { defaultValue: "到刊日期" })}:
                                    </Typography.P>
                                </Col>
                                <Col>
                                    <Input
                                        placeholder={t(`time_start`)}
                                        type="date"
                                        value={tableSearchParams?.start_planneddate ? tableSearchParams?.start_planneddate : ""}
                                        onChange={(e) => {
                                            setTableSearchParams((pre) => {
                                                if (dayjs(e.target.value).isBefore(dayjs(pre?.end_planneddate, "YYYY-MM-DD"))) {
                                                    return {
                                                        ...pre,
                                                        start_planneddate: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        start_planneddate: pre?.end_planneddate,
                                                        end_planneddate: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Typography.Title level={4}>
                                        ~
                                    </Typography.Title>
                                </Col>
                                <Col>
                                    <Input
                                        placeholder={t(`time_end`)}
                                        type="date"
                                        value={tableSearchParams?.end_planneddate ? tableSearchParams?.end_planneddate : ""}
                                        onChange={(e) => {
                                            setTableSearchParams((pre) => {
                                                if ((dayjs(e.target.value)).isBefore(pre?.start_planneddate)) {
                                                    return {
                                                        ...pre,
                                                        start_planneddate: e.target.value,
                                                        end_planneddate: pre?.start_planneddate,
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        end_planneddate: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                {(tableSearchParams.start_planneddate || tableSearchParams.end_planneddate) &&
                                    <Col>
                                        <Button
                                            type={"icon"}
                                            onClick={() => {
                                                setTableSearchParams((pre) => {
                                                    return {
                                                        ...pre,
                                                        start_planneddate: undefined,
                                                        end_planneddate: undefined
                                                    }
                                                })
                                            }}>
                                            X
                                        </Button>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    ]
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    const order = setOrders(Object.keys(sort || {}).length > 0
                        ? sort
                        : { bib_title_subtitle: "ascend", serialseq: "descend" });
                    let newTableSearchParams = { ...tableSearchParams }

                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        concise_bib_title: conciseBibTitle || undefined,
                        // subscriptionid: tableSearchParams?.subscriptionid,
                        ...newTableSearchParams,

                        // status: "1"
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return SerialReceiveController.getData(newParams, { useCancelToken: true });
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }
                propsPatchProcess={(data) => {
                    let notforloan_options = options?.notforloan_options
                    let not_for_loan_status = notforloan_options?.find((ele) => ele?.lib_opac.includes("現刊不可"))?.authorised_value
                    let hasItem = data?.item_data.length > 0
                    let item_data = hasItem ? [] : [
                        {
                            biblio_id: data?.biblionumber,
                            biblionumber: data?.biblionumber,
                            serial_issue_number: data?.serialseq,
                            acquisition_date: dayjs().format("YYYY-MM-DD"),
                            "materials_notes": "",
                            "home_library_id": data?.branchcode,
                            "holding_library_id": data?.branchcode,
                            "item_type_id": data?.item_type_id,
                            "acquisition_source": null,
                            "coded_location_qualifier": null,
                            "purchase_price": null,
                            "inventory_number": null,
                            "callnumber": null,
                            "external_id": null,
                            "copy_number": null,
                            "uri": null,
                            "replacement_price": null,
                            "replacement_price_date": null,
                            "internal_notes": null,
                            "public_notes": null,
                            not_for_loan_status,
                            serialid: data?.serialid
                        }
                    ]

                    return {
                        ...data,
                        planneddate: dayjs(data?.planneddate).format("YYYY-MM-DD"),
                        publisheddate: dayjs(data?.publisheddate).format("YYYY-MM-DD"),
                        item_data,
                        old_status: data?.status,
                        axiosMode: "patch",
                    }
                }}
                initialValues={{
                    "axiosMode": "patch",
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,
                        axiosMode: "post"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {
                            let postData = formData.map((formValue) => {
                                return {
                                    ...formValue,

                                }
                            })
                            SerialReceiveController.postData(postData)
                        },
                        patchData: (formData) => {
                            return new Promise((resolve) => {
                                let errorCount = 0;
                                let items_data = [];
                                let isChangeStatusFromArrivedArray = [];
                                let patchData = formData.map((formValue) => {
                                    if (formValue?.status !== 2 && (formValue?.item_data || []).length > 0) {
                                        errorCount++;
                                    }
                                    if (formValue?.old_status === 2 && formValue?.old_status !== formValue?.status) {
                                        isChangeStatusFromArrivedArray.push(1);
                                    } else {
                                        isChangeStatusFromArrivedArray.push(0);
                                    }
                                    formValue?.item_data.forEach((ele) => {
                                        let collection_code = ele.collection_code === "0" ? null : ele?.collection_code;
                                        let shelving_control_number = ele?.shelving_control_number ?? null;
                                        items_data.push({
                                            ...ele,
                                            shelving_control_number,
                                            collection_code,
                                            serialid: formValue?.serialid,
                                            purchase_price: ele?.purchase_price || null,
                                            replacement_price: ele?.replacement_price || null,
                                            replacement_price_date: ele?.replacement_price_date || null,

                                        });
                                    });
                                    return {
                                        file_id: formValue?.file_id ?? null,
                                        serialid: formValue?.serialid,
                                        biblionumber: formValue?.biblionumber,
                                        subscriptionid: formValue?.subscriptionid,
                                        serialseq: formValue?.serialseq,
                                        serialseq_x: formValue?.serialseq_x ?? 0,
                                        serialseq_y: formValue?.serialseq_y ?? 0,
                                        serialseq_z: formValue?.serialseq_z ?? 0,
                                        status: formValue?.status,
                                        planneddate: formValue?.planneddate,
                                        notes: formValue?.notes || "",
                                        publisheddate: formValue?.publisheddate,
                                        publisheddatetext: formValue?.publisheddatetext || "",
                                        claimdate: formValue?.claimdate ?? null,
                                        claims_count: formValue?.claims_count,
                                        routingnotes: formValue?.claimdate ?? null,
                                    };
                                });

                                if (errorCount) {
                                    message.warning('請確認已到館狀態的期刊才可以新增館藏');
                                    resolve(); // 還是要 resolve 避免卡住 loading
                                } else {
                                    const doPostAndPatch = async () => {
                                        try {
                                            if (items_data.length > 0) {
                                                const itemResponse = await ItemSerialController.postData(items_data, "response");
                                                if (itemResponse?.status !== "success") {
                                                    throw new Error(itemResponse?.message || "館藏新增失敗");
                                                }
                                            }
                                            await SerialReceiveController.patchData(patchData);
                                            resolve();
                                        } catch (e) {
                                            // API 錯誤已由 onItemFinish 顯示；正常結束提交流程，
                                            // 避免 ModifyModal 因 rejected Promise 永久停在 loading。
                                            resolve();
                                        }
                                    };

                                    if (isChangeStatusFromArrivedArray.includes(1)) {
                                        Modal.confirm({
                                            title: "狀態變更提醒",
                                            okText: "確定",
                                            okType: "danger",
                                            cancelText: "取消",
                                            content: "確認要從“已到館”狀態變更嗎？",
                                            width: 250,
                                            onOk: doPostAndPatch,
                                            onCancel: resolve // 使用者取消也要結束 loading
                                        });
                                    } else {
                                        doPostAndPatch();
                                    }
                                }
                            })
                        },
                        deleteData: SerialReceiveController.deleteData
                    }
                }}
                PropsPatchForm={<SerialReceiveForm
                    notforloan_options={options?.notforloan_options || []}
                    onCoverChanged={() => actionRef.current?.reload()}
                />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={permission_level === 1 ? true : false}
                propsDelete={permission_level === 1 ? true : false}
                propsPost={false}
                propsWidth={2400}
                scroll={{
                    x: "100%",
                }}
                extraActionRender={(record) => {
                    let notforloan_options = options?.notforloan_options
                    let not_for_loan_status = notforloan_options?.find((ele) => ele?.lib_opac.includes("現刊不可"))?.authorised_value
                    return (<Col>
                        <Button
                            onClick={() => {
                                let newValue = {
                                    "biblionumber": record?.biblionumber,
                                    "bib_cover_images": record?.bib_cover_images || [],
                                    "bibitem_isbn": record?.bibitem_isbn,
                                    "bib_title_subtitle": record?.bib_title_subtitle,
                                    "subscriptionid": record?.subscriptionid,
                                    "serialseq": null,
                                    "serialseq_x": record?.serialseq_x,
                                    "serialseq_y": record?.serialseq_y,
                                    "serialseq_z": record?.serialseq_z,
                                    "status": 2,
                                    "planneddate": dayjs().format("YYYY-MM-DD"),
                                    "notes": "",
                                    "publisheddate": dayjs().format("YYYY-MM-DD"),
                                    "publisheddatetext": "",
                                    "claimdate": null,
                                    "claims_count": record?.claims_count,
                                    "routingnotes": record?.routingnotes,
                                    item_data: [
                                        {
                                            biblio_id: record?.biblionumber,
                                            biblionumber: record?.biblionumber,
                                            serial_issue_number: null,
                                            acquisition_date: dayjs().format("YYYY-MM-DD"),
                                            "materials_notes": null,
                                            "home_library_id": record?.branchcode,
                                            "holding_library_id": record?.branchcode,
                                            "item_type_id": record?.item_type_id,
                                            "acquisition_source": null,
                                            "coded_location_qualifier": null,
                                            "purchase_price": null,
                                            "inventory_number": null,
                                            "callnumber": null,
                                            "external_id": null,
                                            "copy_number": null,
                                            "uri": null,
                                            "replacement_price": null,
                                            "replacement_price_date": null,
                                            "internal_notes": null,
                                            "public_notes": null,
                                            not_for_loan_status
                                        }
                                    ]
                                }
                                form.setFieldsValue(newValue)
                                setReceivePostModalOpen(true)
                            }}>
                            額外點收新增
                        </Button>
                    </Col>)
                }}
            />
        </Col>
    </Row>)

}
const SerialReceive = ({
    propsBranchcode,
    keyPrefix = "cataloging.serial_receive",
    permission_level = null, 
    conciseBibTitle = false,
}) => {

    const [searchParams, setSearchParams] = useSearchParams();
    // const subscriptionid = searchParams.get('subscriptionid');
    const branchcode = searchParams.get('branchcode');
    const biblionumber = searchParams.get('biblionumber');
    const subscription_orderlist_id = searchParams.get('subscription_orderlist_id');
    return (
        <Row
            gutter={[10, 20]}
        >
            <Col span={24}>
                <SerialReceiveTable
                    keyPrefix={keyPrefix}
                    // propsSubscriptionid={subscriptionid}
                    permission_level={permission_level}
                    propsBranchcode={propsBranchcode ? propsBranchcode : branchcode}
                    propsSubscriptionOrderlistId={subscription_orderlist_id}
                    propsBiblionumber={biblionumber}
                    conciseBibTitle={conciseBibTitle}
                />
            </Col>
        </Row>
    );
};

const ReceivedItemForm = ({
    propsForm,
    field,
    propsOptions,
    defaultBranchcode,
    ...props
}) => {
    const homeLibraryId = Form.useWatch(
        ['recordset', field?.name ?? 0, 'home_library_id'],
        propsForm
    )
    const selectedBranchcode = homeLibraryId || defaultBranchcode
    const shelvingLocationOptions = (propsOptions?.location_options || []).filter((location) => {
        const branches = Array.isArray(location?.branches) ? location.branches : []

        return !selectedBranchcode
            || branches.length === 0
            || branches.some((branch) => String(branch?.branchcode) === String(selectedBranchcode))
    })

    return <ItemForm
        {...props}
        propsForm={propsForm}
        field={field}
        locationMenuPortalTarget={null}
        allowedItemTypeLabels={['中文期刊', '西文期刊', '期刊合訂本']}
        syncCopyNumberOnGenerate={false}
        propsOptions={{
            ...propsOptions,
            location_options: shelvingLocationOptions,
        }}
    />
}

const ReceivedItemTable = ({
    serialid,
    bib_biblionumber = 0,
    keyPrefix = "library.bookdetail",
    customColumns = [],
    receiveValue,
}) => {
    // const { t } = useTranslation('translation')
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef()
    const columns = [
        {
            title: "期刊名稱",
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 200,
            render: (text, record, index) => {
                return (<ExpandableText
                    text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}`}
                    maxLines={2}>
                </ExpandableText>)

            }
        },

        {
            title: t(`Images`),
            dataIndex: 'file_id',
            key: 'file_id',
            sorter: false,
            width: 50,
            render: (text, record, index) => {
                if (!!text) {
                    return (<ImageFileId
                        file_id={text}
                        width={"50px"}
                    />)
                }
                else {
                    return ("-")
                }

            }
        },
        {
            title: t(`Item_type`),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t(`Current library`),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t(`Home library`),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t(`Call_number`),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t(`serial_enumeration_chronology`),
            dataIndex: 'item_serial_issue_number',
            key: 'item_serial_issue_number',
        },
        {
            title: t(`Status`),
            dataIndex: 'issue_cancheckout',
            key: 'issue_cancheckout',
            render: (text, record, index) => {
                let tags = ['item_damaged_authorised_values', 'item_notforloan_authorised_values', 'item_restricted_authorised_values', 'item_withdrawn_authorised_values']
                let statusCount = 0
                tags.forEach((ele) => {
                    if (!!record?.[ele]) {
                        statusCount++
                    }
                })
                if (!!record?.issue_cancheckout) {
                    return <>
                        {t(`CanCheckout`)}
                    </>
                }
                else {
                    if (statusCount > 0) {
                        return (<>
                            不可借出
                            <p>
                                {record?.item_damaged_authorised_values && <Badge>
                                    {record?.item_damaged_authorised_values}
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_notforloan_authorised_values && <Badge>
                                    {record?.item_notforloan_authorised_values}
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_restricted_authorised_values && <Badge>
                                    {record?.item_restricted_authorised_values}
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_withdrawn_authorised_values && <Badge>
                                    {record?.item_withdrawn_authorised_values}
                                </Badge>}
                            </p>

                        </>)
                    }
                    else {
                        return t(`CantCheckout`)
                    }

                }
            }
        },
        {
            title: t(`Last seen`),
            dataIndex: 'item_lastseen',
            key: 'item_lastseen',
        },
        {
            title: t(`Date accessioned`),
            dataIndex: 'item_dateaccessioned',
            key: 'item_dateaccessioned',
            render: (text, record, index) => {
                return <>
                    {dayjs(text).format("YYYY-MM-DD")}
                </>
            }
        },
        {
            title: t(`Date last borrowed`),
            dataIndex: 'item_datelastborrowed',
            key: 'item_datelastborrowed',
            render: (text, record, index) => {
                return <>
                    {text && dayjs(text).format("YYYY-MM-DD")}
                </>
            }
        },
        {
            title: t(`Barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t(`Copy number`),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        },
        {
            title: t('attachment'),
            dataIndex: 'item_internal_notes',
            key: 'item_internal_notes',
        },
    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);  //modal打開或關閉
    const [options, setOptions] = useState({
        withdrawn_options: [],
        call_number_source_options: [],
        damaged_options: [],
        restricted_options: [],
        notforloan_options: [],
        collection_options: [],
        library_options: [],
        location_options: [],
        shelving_control_number_options: [],
        item_type_options: []
    })
    const [search, setSearch] = useState({
        item_dateaccessioned_start: dayjs().subtract(5, 'year').format('YYYY-MM-DD'),
        item_dateaccessioned_end: dayjs().format('YYYY-MM-DD'),
    })
    //勾選的設定，之後可以改一下
    const rowSelection = {
        //不一定都是對id
        // 全選的
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.tag_id); //這個要自己改掉 改成你的id key
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.tag_id);//這個要自己改掉 改成你的id key
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        // 單一勾選
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.tag_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.tag_id
                );
                selectRow = selectRow.filter(
                    (row) => row.tag_id !== record.tag_id
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };


    const onFinish = ({ axiosMode, status, values, responseData, ex }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest(); //table 重整，包含頁數回到第一頁 
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]); //table 重整，包含頁數回到第一頁 
                setSelectedRowsInfo([]);
            } else if (axiosMode === "import") {
                message.success("匯入成功");
                actionRef.current.reloadAndRest();
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                const errorValues = values ?? responseData ?? ex?.response?.data ?? ex?.message;
                message.error(getItemRequestErrorMessage(errorValues, "新增"));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                const errorValues = values ?? responseData ?? ex?.response?.data ?? ex?.message;
                message.error(getItemRequestErrorMessage(errorValues, "修改"));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalOpen(false);
        }
    };
    function convertBooleansToInts(obj) {
        if (Array.isArray(obj)) {
            return obj.map(convertBooleansToInts);
        }

        if (obj !== null && typeof obj === 'object') {
            const result = {};
            for (const key in obj) {
                const value = obj[key];
                if (typeof value === 'boolean') {
                    result[key] = value ? 1 : 0;
                } else if (typeof value === 'object') {
                    result[key] = convertBooleansToInts(value); // 遞迴處理巢狀結構
                } else {
                    result[key] = value;
                }
            }
            return result;
        }

        return obj;
    }
    const {
        transformData,
        getItemData,
        postItemData,
        patchItemData,
        deleteItemData,

    } = useItem({
        onBefore: () => { },
        onFinish: onFinish
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns
    })
    const {
        getItem_ApiData
    } = useItem({

    })
    const ReceiveItemController = useCRUDController({
        apiRoute: "/koha/serial/receive/items",
    })
    const ItemSerialController = useCRUDController({
        apiRoute: "/koha/item/serial",
        onFinish,
    })
    const ShelvingLocationController = useCRUDController({
        apiRoute: "/koha/authorised_values",
    })
    useEffect(() => {
        getItem_ApiData({
            itemnumber: "0"
        })
            .then((response) => {
                let datas = response?.data
                let firstData = datas?.find((ele) => true)
                setOptions((pre) => {
                    return {
                        withdrawn_options: firstData?.withdrawn_options,
                        call_number_source_options: firstData?.call_number_source_options,
                        damaged_options: firstData?.damaged_options,
                        restricted_options: firstData?.restricted_options,
                        notforloan_options: firstData?.notforloan_options,
                        collection_options: firstData?.collection_options,
                        library_options: firstData?.library_options,
                        location_options: pre.location_options,
                        shelving_control_number_options: firstData?.shelving_control_number_options,
                        item_type_options: firstData?.item_type_options,
                    }
                })
            })

        ShelvingLocationController.getData({
            category: "LOC",
        }).then((response) => {
            const locationOptions = (response?.data || [])
                .filter((location) => location?.category === "LOC")
                .map((location) => ({
                    ...location,
                    lib_opac: location?.description_opac || location?.description,
                }))

            setOptions((pre) => ({
                ...pre,
                location_options: locationOptions,
            }))
        })
    }, [])
    return (
        <Row>
            <Col span={24}>
                <ProTableOt
                    searchParams={{ ...search }}
                    rowKey={'item_itemnumber'}
                    actionRef={actionRef}
                    columns={columns}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                            ...search
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            keyword: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        return ReceiveItemController.getData({
                            serialid,
                            ...newParams
                        })
                    }}

                    toolBarRender={() => {
                        return ([

                        ])
                    }}
                    check={check}
                    setCheck={setCheck}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        ...rowSelection,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo
                    }}

                    propsPatchOnBefore={(record) => {
                        //serialid 為了取得索書號需要帶入進去
                        return {
                            ...record,
                            serialid
                        }
                    }}
                    PropsPatchForm={<ReceivedItemForm
                        propsOptions={options}
                        isPropsOptions={true}
                        isSerial={true}
                        defaultBranchcode={receiveValue?.branchcode}
                    />}
                    propsUseData={() => {
                        return {
                            postData: (data) => {
                                let newData = data?.map((val) => {
                                    return {
                                        ...val,
                                        biblionumber: bib_biblionumber,
                                        biblio_id: bib_biblionumber,
                                        internal_notes: val?.item_internal_notes,
                                        not_for_loan_status: val?.not_for_loan_status ?? 0,
                                        collection_code: val?.collection_code ?? 0,
                                        restricted_status: val?.restricted_status ?? 0,
                                        damaged_status: val?.damaged_status ?? 0,
                                        withdrawn: val?.withdrawn ?? 0,
                                        serialid,
                                        purchase_price: val?.purchase_price || null,
                                        replacement_price: val?.replacement_price || null,
                                        replacement_price_date: val?.replacement_price_date || null,

                                    }
                                })
                                ItemSerialController.postData(newData)
                            },
                            patchData: (data) => {
                                let output = data.map(convertBooleansToInts);
                                let newData = output?.map((val) => {
                                    return {
                                        ...val,
                                        sync_scrapped_list: true,
                                        not_for_loan_status: val?.not_for_loan_status ?? 0,
                                        collection_code: val?.collection_code ?? 0,
                                        restricted_status: val?.restricted_status ?? 0,
                                        damaged_status: val?.damaged_status ?? 0,
                                        withdrawn: val?.withdrawn ?? 0,
                                        itemnumber: val?.item_itemnumber,
                                        purchase_price: val?.purchase_price || null,
                                        replacement_price: val?.replacement_price || null,
                                        replacement_price_date: val?.replacement_price_date || null,

                                    }
                                })
                                patchItemData(newData)
                            },
                            deleteData: (data) => {
                                let newdeleteData = data?.map((val) => {
                                    return {
                                        ...val,
                                        itemnumber: val?.item_itemnumber,
                                    }
                                })
                                deleteItemData(newdeleteData)
                            },
                        }
                    }}
                    propsPatch={true}
                    propsPatchProcess={(record) => {
                        let newRecord = transformData(record)
                        return {
                            ...newRecord,
                            serialid
                        }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsDelete={true}
                    propsPatchOnFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}

                    propsPost={!!bib_biblionumber}
                    // propsPostOnBefore
                    initialValues={
                        {
                            biblionumber: bib_biblionumber,
                            biblio_id: receiveValue?.biblionumber,
                            serial_issue_number: receiveValue?.serialseq,
                            acquisition_date: dayjs().format("YYYY-MM-DD"),
                            "materials_notes": null,
                            "home_library_id": receiveValue?.branchcode,
                            "holding_library_id": receiveValue?.branchcode,
                            "item_type_id": receiveValue?.item_type_id,
                            "acquisition_source": null,
                            "coded_location_qualifier": null,
                            "purchase_price": null,
                            "inventory_number": null,
                            "callnumber": null,
                            "external_id": null,
                            "copy_number": null,
                            "uri": null,
                            "replacement_price": null,
                            "replacement_price_date": null,
                            "internal_notes": null,
                            "public_notes": null,
                            file_id: receiveValue?.file_id,
                            serialid

                        }
                    }
                    propsWidth={1500}
                    formMode={true}
                />
            </Col>
        </Row>
    )
}

export { SerialReceiveTable }
export default SerialReceive;
